/* Brain Bumps Theme — brain-bumps.js */
(function() {
  'use strict';

  /* ── Helpers ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function money(cents) {
    var n = (cents || 0) / 100;
    var hasCents = Math.round(n * 100) % 100 !== 0;
    return '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    });
  }
  function subscribePrice(variant, sellingPlanId) {
    if (!variant) return 0;
    if (typeof variant.subscribe_price === 'number') return variant.subscribe_price;
    var allocs = variant.selling_plan_allocations || [];
    if (allocs.length && sellingPlanId) {
      for (var i = 0; i < allocs.length; i++) {
        if (String(allocs[i].selling_plan_id) === String(sellingPlanId)) return allocs[i].price;
      }
      return allocs[0].price;
    }
    if (allocs.length) return allocs[0].price;
    return Math.round(variant.price * 0.85);
  }

  /* ── Scroll reveal ── */
  function initReveal() {
    var nodes = qsa('[data-reveal]');
    // Mark above-fold visible BEFORE enabling hide styles (avoids a flash of invisible content).
    nodes.forEach(function(el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.dataset.revealed = '1';
      } else if (el.dataset.revealed !== '1') {
        el.dataset.revealed = '0';
      }
    });
    try { document.documentElement.classList.add('bb-js'); } catch (err) {}

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.dataset.revealed = '1';
          io.unobserve(e.target);
          try {
            if (e.target.classList.contains('bb-loox-reviews') || e.target.querySelector('.bb-loox-reviews, .loox-v2-carousel-container, #looxReviews')) {
              if (window.Loox && typeof window.Loox.reload === 'function') window.Loox.reload();
              window.dispatchEvent(new Event('resize'));
            }
          } catch (e2) {}
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 10% 0px' });
    nodes.forEach(function(el) {
      if (el.dataset.revealed !== '1') io.observe(el);
    });
  }

  /* ── Sticky nav ── */
  function initNav() {
    var nav = qs('.bb-nav');
    if (!nav) return;
    function onScroll() {
      nav.classList.toggle('scrolled', window.scrollY > 24);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav drawer (focus trap + inert background) ── */
  function initDrawer() {
    var burger = qs('#bb-nav-burger');
    var drawer = qs('#bb-drawer');
    var backdrop = qs('#bb-drawer-backdrop');
    var closeBtn = qs('#bb-drawer-close');
    if (!burger || !drawer) return;
    var lastFocus = null;
    var inertTargets = [];

    function getFocusable(root) {
      return qsa('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])', root)
        .filter(function(el) { return !el.hasAttribute('disabled') && el.offsetParent !== null; });
    }

    function setBackgroundInert(on) {
      if (on) {
        inertTargets = qsa('main, .bb-nav, .bb-announcement, .bb-footer, #bb-sticky-bar, #bb-cart-notification, #bb-cookie')
          .filter(function(el) { return el && !drawer.contains(el); });
        inertTargets.forEach(function(el) {
          el.setAttribute('inert', '');
          el.setAttribute('aria-hidden', 'true');
        });
      } else {
        inertTargets.forEach(function(el) {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        });
        inertTargets = [];
      }
    }

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        if (backdrop) backdrop.hidden = false;
        setBackgroundInert(true);
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            document.body.classList.add('bb-drawer-open');
            var closeFocus = qs('#bb-drawer-close', drawer);
            if (closeFocus) closeFocus.focus();
          });
        });
      } else {
        document.body.classList.remove('bb-drawer-open');
        setBackgroundInert(false);
        setTimeout(function() {
          if (!document.body.classList.contains('bb-drawer-open')) {
            drawer.hidden = true;
            if (backdrop) backdrop.hidden = true;
          }
        }, 350);
        (lastFocus || burger).focus();
      }
    }

    on(burger, 'click', function() { setOpen(true); });
    on(closeBtn, 'click', function() { setOpen(false); });
    on(backdrop, 'click', function() { setOpen(false); });
    document.addEventListener('keydown', function(e) {
      if (!document.body.classList.contains('bb-drawer-open')) return;
      if (e.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = getFocusable(drawer);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ── Nav dropdown disclosure ── */
  function initNavDropdown() {
    var dd = qs('.bb-nav-dd');
    if (!dd) return;
    var trigger = qs('.bb-nav-dd-trigger', dd);
    var menu = qs('.bb-nav-dd-menu', dd);
    if (!trigger || !menu) return;

    function setExpanded(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      dd.classList.toggle('bb-nav-dd--open', open);
    }

    on(trigger, 'click', function() {
      setExpanded(trigger.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
        setExpanded(false);
        trigger.focus();
      }
    });
    document.addEventListener('click', function(e) {
      if (!dd.contains(e.target)) setExpanded(false);
    });
  }

  /* ── FAQ accordion ── */
  function initFAQ() {
    qsa('.bb-faq-item').forEach(function(item) {
      var trigger = qs('.bb-faq-trigger', item);
      var panel = qs('.bb-faq-body', item);
      if (!trigger) return;
      if (panel && !item.classList.contains('open')) panel.hidden = true;
      on(trigger, 'click', function() {
        var isOpen = item.classList.contains('open');
        qsa('.bb-faq-item.open').forEach(function(o) {
          o.classList.remove('open');
          var t = qs('.bb-faq-trigger', o);
          var p = qs('.bb-faq-body', o);
          if (t) t.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
        }
      });
    });
  }

  /* ── Ingredient tabs (APG pattern) ── */
  function initIngTabs() {
    qsa('.bb-ing-tabs').forEach(function(container) {
      var tabs = qsa('.bb-ing-tab', container);
      var panels = qsa('.bb-ing-panel', container.closest('.bb-ing-section') || document);

      function activate(tab, focusTab) {
        var target = tab.dataset.target;
        tabs.forEach(function(t) {
          var selected = t === tab;
          t.className = t.className.replace(/active--\w+/g, '').trim();
          if (selected) t.classList.add('active--' + (t.dataset.color || 'blue'));
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(function(p) {
          var on = p.dataset.panel === target;
          p.classList.toggle('active', on);
          p.hidden = !on;
        });
        if (focusTab) tab.focus();
      }

      tabs.forEach(function(tab, index) {
        on(tab, 'click', function() { activate(tab, false); });
        on(tab, 'keydown', function(e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            activate(next, true);
          }
        });
      });
    });
  }

  /* ── Product page ── */
  window.BrainBumps = window.BrainBumps || {};

  window.BrainBumps.initProduct = function(config) {
    var sectionId = config.sectionId;
    var sellingPlanId = config.sellingPlanId;
    var variants = config.variants || [];

    // Gallery — bind even if the product form is missing so thumbs always work.
    // Important: clear srcset when swapping; otherwise the browser keeps the
    // featured image from the original srcset and ignores the new src.
    var galleryMain = qs('#bb-main-image') || qs('.bb-gallery-main img');
    var galleryContainer = qs('.bb-gallery-main');
    var thumbs = qsa('.bb-thumb');
    function setMainImage(url, alt, bg, srcset) {
      if (galleryMain && url) {
        galleryMain.removeAttribute('srcset');
        galleryMain.removeAttribute('sizes');
        galleryMain.src = url;
        if (srcset) {
          galleryMain.setAttribute('srcset', srcset);
          galleryMain.setAttribute('sizes', '(max-width: 900px) 92vw, 620px');
        }
        if (alt) galleryMain.alt = alt;
      }
      if (galleryContainer && bg) galleryContainer.style.background = bg;
    }
    function selectThumb(thumb) {
      if (!thumb) return;
      var url = thumb.getAttribute('data-image-url') || thumb.dataset.imageUrl;
      var srcset = thumb.getAttribute('data-image-srcset') || '';
      var bg = thumb.getAttribute('data-bg') || thumb.dataset.bg || '';
      var alt = thumb.getAttribute('data-alt') || thumb.dataset.alt || '';
      setMainImage(url, alt, bg, srcset);
      thumbs.forEach(function(t) {
        var onThumb = t === thumb;
        t.classList.toggle('active', onThumb);
        t.setAttribute('aria-current', onThumb ? 'true' : 'false');
      });
    }
    function selectThumbByImageUrl(url) {
      if (!url) return;
      var match = thumbs.find(function(t) {
        return (t.getAttribute('data-image-url') || t.dataset.imageUrl) === url;
      });
      if (match) selectThumb(match);
      else setMainImage(url, '', '', '');
    }
    thumbs.forEach(function(thumb) {
      on(thumb, 'click', function(e) {
        e.preventDefault();
        selectThumb(thumb);
      });
    });

    // Prefer the section form id; fall back if Liquid left a literal id attribute.
    var form = qs('#product-form-' + sectionId)
      || qs('form[data-type="add-to-cart-form"]')
      || qs('form.shopify-product-form');
    if (!form) return;

    // State — trust the server-rendered selection (Liquid checks current_variant)
    var checkedRadio = qs('input[name="id"]:checked', form);
    var activeVariantId = checkedRadio ? parseInt(checkedRadio.value, 10)
      : (variants[0] ? variants[0].id : null);
    var purchaseType = 'subscribe'; // default

    // Elements
    var variantCards = qsa('.bb-variant-card', form);
    var toggleOnce = qs('.bb-toggle-btn[data-type="once"]', form);
    var toggleSubscribe = qs('.bb-toggle-btn[data-type="subscribe"]', form);
    var sellingPlanInput = qs('input[name="selling_plan"]', form);
    var mainPrice = qs('.bb-price-main', form.parentElement || document);
    var originalPrice = qs('.bb-price-original', form.parentElement || document);
    var savingsBadge = qs('.bb-price-savings-badge', form.parentElement || document);
    var perTablet = qs('.bb-per-tablet', form.parentElement || document);
    var atcPriceEl = qs('.bb-atc-price', form);
    var subscribeNote = qs('.bb-subscribe-note', form.parentElement || document);
    var stickyBar = qs('.bb-sticky-bar');
    var stickyPriceEl = qs('.bb-sticky-price-main', stickyBar || document);
    var addToCartBtn = qs('[data-atc-anchor]');

    // Variant counting helper
    function getTabCount(variantTitle) {
      var match = (variantTitle || '').match(/^(\d+)/);
      return match ? parseInt(match[1], 10) : 1;
    }

    function getActiveVariant() {
      return variants.find(function(v) { return v.id === activeVariantId; }) || variants[0];
    }

    function updateVariantCards() {
      var isSubscribe = purchaseType === 'subscribe' && sellingPlanId;
      variantCards.forEach(function(card) {
        var once = parseInt(card.dataset.price, 10);
        var sub = parseInt(card.dataset.subscribePrice, 10);
        var tabs = parseInt(card.dataset.tabs, 10) || 1;
        if (isNaN(once)) return;
        var price = isSubscribe && !isNaN(sub) ? sub : once;
        var priceEl = qs('.bb-variant-price-val', card);
        var perEl = qs('.bb-variant-pertab', card);
        if (priceEl) priceEl.textContent = money(price);
        if (perEl) perEl.textContent = '$' + (price / tabs / 100).toFixed(2) + ' per tablet';
      });
    }

    function updatePriceDisplay() {
      var v = getActiveVariant();
      if (!v) return;
      var base = v.price; // cents
      var isSubscribe = purchaseType === 'subscribe' && sellingPlanId;
      var display = isSubscribe ? subscribePrice(v, sellingPlanId) : base;

      if (mainPrice) {
        mainPrice.innerHTML = '<span class="visually-hidden">' + (isSubscribe ? 'Sale price ' : 'Price ') + '</span>' + money(display);
      }
      if (originalPrice) {
        if (isSubscribe) {
          originalPrice.innerHTML = '<span class="visually-hidden">Regular price </span>' + money(base);
          originalPrice.style.display = '';
        } else {
          originalPrice.style.display = 'none';
        }
      }
      if (savingsBadge) {
        savingsBadge.style.display = isSubscribe ? '' : 'none';
      }
      var tc = getTabCount(v.title);
      if (perTablet) perTablet.textContent = '$' + (display / tc / 100).toFixed(2) + ' / tablet';
      if (atcPriceEl) atcPriceEl.textContent = money(display);
      if (stickyPriceEl) stickyPriceEl.textContent = money(display);
      updateVariantCards();
    }

    function setVariant(vid) {
      activeVariantId = vid;
      variantCards.forEach(function(card) {
        var isActive = card.dataset.variantId == vid;
        card.classList.toggle('active', isActive);
        var radio = qs('input[type="radio"]', card);
        if (radio) radio.checked = isActive;
      });
      var v = getActiveVariant();
      if (v && v.featured_image) selectThumbByImageUrl(v.featured_image);
      updatePriceDisplay();
    }

    function setPurchaseType(type) {
      purchaseType = type;
      if (toggleOnce) {
        toggleOnce.classList.toggle('active', type === 'once');
        toggleOnce.setAttribute('aria-pressed', type === 'once' ? 'true' : 'false');
      }
      if (toggleSubscribe) {
        toggleSubscribe.classList.toggle('active', type === 'subscribe');
        toggleSubscribe.setAttribute('aria-pressed', type === 'subscribe' ? 'true' : 'false');
      }
      if (sellingPlanInput) {
        sellingPlanInput.value = (type === 'subscribe' && sellingPlanId) ? sellingPlanId : '';
      }
      if (subscribeNote) subscribeNote.style.display = type === 'subscribe' ? '' : 'none';
      updatePriceDisplay();
    }

    // Bind variant cards
    variantCards.forEach(function(card) {
      on(card, 'click', function() { setVariant(parseInt(card.dataset.variantId, 10)); });
    });

    // Bind purchase type toggle
    on(toggleOnce, 'click', function() { setPurchaseType('once'); });
    on(toggleSubscribe, 'click', function() { setPurchaseType('subscribe'); });

    // Qty buttons
    var qtyInput = qs('.bb-qty-input', form);
    on(qs('.bb-qty-btn--minus', form), 'click', function() {
      if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    on(qs('.bb-qty-btn--plus', form), 'click', function() {
      if (qtyInput) qtyInput.value = Math.min(9, parseInt(qtyInput.value, 10) + 1);
    });

    // Add to cart via AJAX
    function restoreSubmitBtn(btn) {
      var v = getActiveVariant();
      var price = v ? (purchaseType === 'subscribe' && sellingPlanId ? subscribePrice(v, sellingPlanId) : v.price) : 0;
      btn.disabled = false;
      btn.innerHTML = 'Add to Cart — <span class="bb-atc-price">' + money(price) + '</span>';
    }
    on(form, 'submit', function(e) {
      e.preventDefault();
      var submitBtn = qs('[type="submit"]', form);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function(r) { return r.json(); })
        .then(function(item) {
          // Update cart count
          var countEls = qsa('.bb-cart-count');
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              countEls.forEach(function(el) { el.textContent = cart.item_count; });
              qsa('.bb-cart-link').forEach(function(link) {
                var n = cart.item_count;
                link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
              });
            });
          // Show notification
          var notif = qs('#bb-cart-notification');
          var notifItem = qs('#bb-cart-notification-item');
          if (notif) {
            if (notifItem) notifItem.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
            notif.hidden = false;
            clearTimeout(notif._bbHideTimer);
            var scheduleHide = function() {
              clearTimeout(notif._bbHideTimer);
              notif._bbHideTimer = setTimeout(function() { notif.hidden = true; }, 8000);
            };
            scheduleHide();
            notif.onmouseenter = function() { clearTimeout(notif._bbHideTimer); };
            notif.onmouseleave = scheduleHide;
            notif.onfocusin = function() { clearTimeout(notif._bbHideTimer); };
            notif.onfocusout = scheduleHide;
          }
          if (submitBtn) restoreSubmitBtn(submitBtn);
        })
        .catch(function() {
          if (submitBtn) restoreSubmitBtn(submitBtn);
          var notif = qs('#bb-cart-notification');
          var notifItem = qs('#bb-cart-notification-item');
          if (notif) {
            if (notifItem) notifItem.textContent = 'Could not add to cart. Please try again.';
            notif.hidden = false;
          }
        });
    });

    // Sticky bar visibility — show when ATC leaves view, hide once legal/footer is on screen
    if (stickyBar && addToCartBtn) {
      var atcInView = true;
      var hideForFooter = false;
      function syncSticky() {
        stickyBar.classList.toggle('visible', !atcInView && !hideForFooter);
      }
      function checkFooter() {
        hideForFooter = false;
        var legal = document.querySelector('.bb-footer-bottom');
        var footer = document.querySelector('.bb-footer');
        var target = legal || footer;
        if (target && target.getBoundingClientRect().top < window.innerHeight) {
          hideForFooter = true;
        }
        if (footer && footer.getBoundingClientRect().bottom <= window.innerHeight + 2) {
          hideForFooter = true;
        }
        syncSticky();
      }
      var stickyIO = new IntersectionObserver(function(entries) {
        atcInView = !!(entries[0] && entries[0].isIntersecting);
        syncSticky();
      }, { threshold: 0.1 });
      stickyIO.observe(addToCartBtn);
      var footerTick = false;
      window.addEventListener('scroll', function() {
        if (!footerTick) {
          footerTick = true;
          requestAnimationFrame(function() { footerTick = false; checkFooter(); });
        }
      }, { passive: true });
      checkFooter();
    }

    // Init defaults
    setVariant(activeVariantId);
    setPurchaseType(sellingPlanId ? 'subscribe' : 'once');
  };

  /* ── Home buy box — compact pack cards with a shared subscribe/one-time toggle.
        Each card is its own product form (no-JS fallback posts to /cart/add).
        Selection syncs to the site-wide sticky buy bar. ── */
  window.BrainBumps.initBuyBox = function(config) {
    var root = document.getElementById('bb-buybox-' + config.sectionId);
    if (!root) return;

    var cards = qsa('[data-pack-card]', root);
    var toggleWrap = qs('[data-pack-toggle]', root);
    var subnote = qs('[data-pack-subnote]', root);
    var hasPlans = !!toggleWrap;
    var purchaseType = hasPlans ? 'subscribe' : 'once';
    var sellingPlanId = config.sellingPlanId || null;
    var selectedCard = null;

    function cardDetail(card) {
      if (!card) return null;
      return {
        variantId: parseInt(card.dataset.variantId, 10),
        title: card.dataset.variantTitle || '',
        price: parseInt(card.dataset.price, 10),
        subscribePrice: parseInt(card.dataset.subscribePrice, 10),
        tabs: parseInt(card.dataset.tabs, 10) || 1,
        purchaseType: purchaseType,
        sellingPlanId: sellingPlanId
      };
    }

    function publishSelection(card) {
      var detail = cardDetail(card);
      if (!detail || !detail.variantId) return;
      try {
        window.dispatchEvent(new CustomEvent('bb:pack-selected', { detail: detail }));
      } catch (e) {}
      if (window.BrainBumps && typeof window.BrainBumps.syncStickyBuyBar === 'function') {
        window.BrainBumps.syncStickyBuyBar(detail);
      }
    }

    function selectCard(card) {
      if (!card) return;
      selectedCard = card;
      cards.forEach(function(c) {
        var on = c === card;
        c.classList.toggle('bb-pack-card--selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      publishSelection(card);
    }

    function updatePrices() {
      var isSub = purchaseType === 'subscribe' && hasPlans;
      cards.forEach(function(card) {
        var once = parseInt(card.dataset.price, 10);
        var sub = parseInt(card.dataset.subscribePrice, 10);
        var tabs = parseInt(card.dataset.tabs, 10) || 1;
        if (isNaN(once)) return;
        var price = isSub && !isNaN(sub) ? sub : once;
        var priceEl = qs('[data-pack-price]', card);
        var perEl = qs('[data-pack-pertab]', card);
        var compareEl = qs('[data-pack-compare]', card);
        if (priceEl) priceEl.textContent = money(price);
        if (perEl) perEl.textContent = '$' + (price / tabs / 100).toFixed(2);
        if (compareEl) compareEl.hidden = !(isSub && price < once);
        var planInput = qs('[data-pack-plan]', card);
        if (planInput) planInput.disabled = !isSub;
      });
      if (subnote) subnote.style.display = purchaseType === 'subscribe' ? '' : 'none';
      if (selectedCard) publishSelection(selectedCard);
    }

    function setPurchaseType(type) {
      purchaseType = type;
      if (toggleWrap) {
        qsa('.bb-toggle-btn', toggleWrap).forEach(function(btn) {
          var onBtn = btn.dataset.type === type;
          btn.classList.toggle('active', onBtn);
          btn.setAttribute('aria-pressed', onBtn ? 'true' : 'false');
        });
      }
      updatePrices();
    }

    if (toggleWrap) {
      qsa('.bb-toggle-btn', toggleWrap).forEach(function(btn) {
        on(btn, 'click', function() { setPurchaseType(btn.dataset.type); });
      });
    }

    // Select pack on card click / keyboard; ATC still works from the button
    cards.forEach(function(card) {
      on(card, 'click', function(e) {
        if (e.target && e.target.closest('button, a, input, label')) return;
        selectCard(card);
      });
      on(card, 'keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });

      var form = qs('form', card);
      var btn = qs('[type="submit"]', card);
      if (!form || !btn) return;
      on(form, 'submit', function(e) {
        e.preventDefault();
        selectCard(card);
        var prevLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function(r) { return r.json(); })
          .then(function(item) {
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              qsa('.bb-cart-count').forEach(function(el) { el.textContent = cart.item_count; });
            });
            var notif = qs('#bb-cart-notification');
            var notifItem = qs('#bb-cart-notification-item');
            if (notif) {
              if (notifItem) notifItem.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
              notif.hidden = false;
              setTimeout(function() { notif.hidden = true; }, 4000);
            }
            btn.disabled = false;
            btn.textContent = 'Added ✓';
            setTimeout(function() { btn.textContent = prevLabel; }, 1800);
          })
          .catch(function() {
            btn.disabled = false;
            btn.textContent = prevLabel;
          });
      });
    });

    // Default selection: 10-tablet pack (falls back to first card)
    var defaultTabs = config.defaultTabs || 10;
    var defaultCard = qs('.bb-pack-card--selected', root) || cards[0];
    for (var i = 0; i < cards.length; i++) {
      if (parseInt(cards[i].dataset.tabs, 10) === defaultTabs) {
        defaultCard = cards[i];
        break;
      }
    }

    setPurchaseType(purchaseType);
    if (defaultCard) selectCard(defaultCard);

    // On mobile, center the selected pack in the swipe rail
    var rail = qs('[data-pack-grid]', root);
    if (rail && defaultCard && rail.scrollWidth > rail.clientWidth + 10) {
      rail.scrollLeft = defaultCard.offsetLeft - (rail.clientWidth - defaultCard.offsetWidth) / 2;
    }
  };

  /* ── Accessibility widget ── */
  function initA11y() {
    var root = qs('#bb-a11y');
    if (!root) return;
    var trigger = qs('#bb-a11y-trigger', root);
    var panel = qs('#bb-a11y-panel', root);
    var closeBtn = qs('#bb-a11y-close', root);
    var html = document.documentElement;
    var KEY = 'bb-a11y';
    var state = { font: 0, contrast: false, underline: false, motion: false, readable: false, spacing: false, grayscale: false };

    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '{}');
      Object.keys(state).forEach(function(k) {
        if (typeof saved[k] !== 'undefined') state[k] = saved[k];
      });
    } catch (e) {}

    function save() {
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }

    function apply() {
      html.classList.toggle('bb-a11y-contrast', !!state.contrast);
      html.classList.toggle('bb-a11y-underline', !!state.underline);
      html.classList.toggle('bb-a11y-motion', !!state.motion);
      html.classList.toggle('bb-a11y-readable', !!state.readable);
      html.classList.toggle('bb-a11y-spacing', !!state.spacing);
      html.classList.toggle('bb-a11y-grayscale', !!state.grayscale);
      html.style.fontSize = state.font ? (100 + state.font * 12.5) + '%' : '';
      qsa('[data-a11y-toggle]', root).forEach(function(btn) {
        var key = btn.getAttribute('data-a11y-toggle');
        var on = !!state[key];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      save();
    }

    function setOpen(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open) {
        var first = qs('[data-a11y-action], [data-a11y-toggle]', panel);
        if (first) first.focus();
      } else {
        trigger.focus();
      }
    }

    on(trigger, 'click', function() {
      setOpen(panel.hidden);
    });
    on(closeBtn, 'click', function() { setOpen(false); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });
    document.addEventListener('click', function(e) {
      if (!panel.hidden && !root.contains(e.target)) setOpen(false);
    });

    qsa('[data-a11y-action]', root).forEach(function(btn) {
      on(btn, 'click', function() {
        var action = btn.getAttribute('data-a11y-action');
        if (action === 'font-up') state.font = Math.min(3, (state.font || 0) + 1);
        else if (action === 'font-down') state.font = Math.max(-1, (state.font || 0) - 1);
        else if (action === 'font-reset') state.font = 0;
        else if (action === 'reset') {
          state = { font: 0, contrast: false, underline: false, motion: false, readable: false, spacing: false, grayscale: false };
        }
        apply();
      });
    });

    qsa('[data-a11y-toggle]', root).forEach(function(btn) {
      on(btn, 'click', function() {
        var key = btn.getAttribute('data-a11y-toggle');
        state[key] = !state[key];
        apply();
      });
    });

    apply();
  }

  /* ── Affiliate earnings calculator ── */
  function initAffiliateCalc() {
    var root = qs('[data-bb-aff-calc]');
    if (!root) return;
    var ordersEl = qs('[data-bb-aff-orders]', root);
    var aovEl = qs('[data-bb-aff-aov]', root);
    var rate = parseFloat(root.getAttribute('data-commission') || '10') / 100;
    var tiers = qsa('[data-bb-aff-tier]', root);

    function usd(n) {
      return '$' + Math.round(n).toLocaleString('en-US');
    }

    function render() {
      var orders = parseInt(ordersEl && ordersEl.value, 10) || 0;
      var aov = parseInt(aovEl && aovEl.value, 10) || 0;
      var perOrder = aov * rate;
      var monthly = perOrder * orders;
      var weekly = monthly / 4.333;
      var annual = monthly * 12;
      var monthlyEl = qs('[data-bb-aff-monthly]', root);
      var perEl = qs('[data-bb-aff-per-order]', root);
      var weekEl = qs('[data-bb-aff-weekly]', root);
      var yearEl = qs('[data-bb-aff-annual]', root);
      var ordersOut = qs('[data-bb-aff-orders-out]', root);
      var ordersLabel = qs('[data-bb-aff-orders-label]', root);
      var aovOut = qs('[data-bb-aff-aov-out]', root);
      if (monthlyEl) monthlyEl.textContent = usd(monthly);
      if (perEl) perEl.textContent = usd(perOrder);
      if (weekEl) weekEl.textContent = usd(weekly);
      if (yearEl) yearEl.textContent = usd(annual);
      if (ordersOut) ordersOut.textContent = String(orders);
      if (ordersLabel) ordersLabel.textContent = String(orders);
      if (aovOut) aovOut.textContent = usd(aov);
      var active = null;
      tiers.forEach(function(tier) {
        var min = parseInt(tier.getAttribute('data-min'), 10) || 0;
        var on = orders >= min;
        tier.classList.toggle('is-reached', on);
        if (on) active = tier;
      });
      tiers.forEach(function(tier) {
        tier.classList.remove('is-active');
        tier.setAttribute('aria-pressed', 'false');
      });
      if (active) {
        active.classList.add('is-active');
        active.setAttribute('aria-pressed', 'true');
      }
    }

    on(ordersEl, 'input', render);
    on(aovEl, 'input', render);
    tiers.forEach(function(tier) {
      on(tier, 'click', function() {
        var min = parseInt(tier.getAttribute('data-min'), 10) || 0;
        if (!ordersEl) return;
        var max = parseInt(ordersEl.max, 10);
        if (!isNaN(max) && min > max) min = max;
        var floor = parseInt(ordersEl.min, 10);
        if (!isNaN(floor) && min < floor) min = floor;
        ordersEl.value = String(min);
        render();
      });
    });
    render();
  }

  /* ── Affiliate Collabs: style-safe URL bridge + returning-member login ── */
  function initAffiliateCollabs() {
    var apply = qs('.collabs-page__cta-main');
    var login = qs('.collabs-page__cta-login-link');
    if (!apply) return;
    var applyHref = apply.getAttribute('href') || '';
    var loginHref = (login && login.getAttribute('href')) || '';
    if (applyHref.indexOf('collabs.shopify.com') === -1) return;

    qsa('[data-bb-collabs-apply]').forEach(function(link) {
      var href = link.getAttribute('href') || '';
      if (href === '#collabs-apply' || href.indexOf('#collabs-apply') !== -1) {
        link.setAttribute('href', applyHref);
      }
    });

    if (loginHref) {
      var loginLabel = qs('.collabs-page__cta-login-section p');
      if (loginLabel) {
        var custom = document.querySelector('[data-bb-collabs-login-label]');
        loginLabel.textContent = (custom && custom.getAttribute('data-bb-collabs-login-label')) || 'Already a partner?';
      }
      qsa('[data-bb-collabs-login]').forEach(function(link) {
        link.setAttribute('href', loginHref);
      });
      qsa('[data-bb-collabs-login-wrap]').forEach(function(wrap) {
        wrap.hidden = false;
      });
    }
  }

  /* ── Cookie consent (Shopify Customer Privacy + local record) ── */
  function initCookieConsent() {
    var root = qs('[data-bb-cookie]');
    var KEY = 'bb-cookie-consent';
    var banner = root ? qs('#bb-cookie-banner', root) : null;
    var overlay = root ? qs('#bb-cookie-overlay', root) : null;
    var dialog = root ? qs('.bb-cookie-dialog', root) : null;
    var mode = root ? (root.getAttribute('data-mode') || 'until_chosen') : 'until_chosen';
    var lastFocus = null;
    var pendingOpen = false;

    var consent = {
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
      decided: false
    };

    function loadLocal() {
      try {
        var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (saved && typeof saved === 'object') {
          consent.analytics = !!saved.analytics;
          consent.marketing = !!saved.marketing;
          consent.preferences = !!saved.preferences;
          consent.sale_of_data = !!saved.sale_of_data;
          consent.decided = saved.decided !== false;
          return true;
        }
      } catch (e) {}
      return false;
    }

    function saveLocal() {
      try {
        localStorage.setItem(KEY, JSON.stringify({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.sale_of_data,
          decided: true,
          ts: Date.now()
        }));
      } catch (e) {}
    }

    function boolFromShopify(value) {
      return value === true || value === 'yes' || value === '1';
    }

    function applyToggles() {
      if (!root) return;
      qsa('[data-bb-cookie-toggle]', root).forEach(function(btn) {
        var key = btn.getAttribute('data-bb-cookie-toggle');
        var on = !!consent[key];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setBannerVisible(show) {
      if (!banner) return;
      banner.hidden = !show;
      document.body.classList.toggle('bb-cookie-banner-visible', !!show);
    }

    function getFocusable(container) {
      return qsa('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])', container)
        .filter(function(el) { return !el.hasAttribute('disabled') && el.offsetParent !== null; });
    }

    function setModalOpen(open) {
      if (!overlay || !dialog) return;
      overlay.hidden = !open;
      document.body.classList.toggle('bb-cookie-modal-open', !!open);
      if (open) {
        lastFocus = document.activeElement;
        applyToggles();
        var first = getFocusable(dialog)[0];
        if (first) first.focus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }

    function withPrivacy(cb) {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.setTrackingConsent === 'function') {
        cb(Shopify.customerPrivacy);
        return;
      }
      if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err) {
          if (err || !Shopify.customerPrivacy) { cb(null); return; }
          cb(Shopify.customerPrivacy);
        });
        return;
      }
      cb(null);
    }

    function syncShopify(done) {
      withPrivacy(function(api) {
        if (!api || typeof api.setTrackingConsent !== 'function') {
          if (done) done();
          return;
        }
        try {
          api.setTrackingConsent({
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            preferences: !!consent.preferences,
            sale_of_data: !!consent.sale_of_data
          }, function() { if (done) done(); });
        } catch (e) {
          if (done) done();
        }
      });
    }

    function applyGtagConsent() {
      if (typeof window.gtag !== 'function') return;
      var analyticsOn = !!consent.analytics;
      var adsOn = !!consent.marketing;
      window.gtag('consent', 'update', {
        analytics_storage: analyticsOn ? 'granted' : 'denied',
        ad_storage: adsOn ? 'granted' : 'denied',
        ad_user_data: adsOn ? 'granted' : 'denied',
        ad_personalization: adsOn ? 'granted' : 'denied'
      });
    }

    function commit(partial, then) {
      if (partial) {
        Object.keys(partial).forEach(function(k) { consent[k] = !!partial[k]; });
      }
      consent.decided = true;
      saveLocal();
      applyToggles();
      applyGtagConsent();
      setBannerVisible(false);
      setModalOpen(false);
      document.dispatchEvent(new CustomEvent('bb:consent-updated', { detail: {
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: !!consent.preferences,
        sale_of_data: !!consent.sale_of_data
      }}));
      syncShopify(then);
    }

    function acceptAll() {
      commit({
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true
      });
    }

    function rejectOptional() {
      commit({
        analytics: false,
        marketing: false,
        preferences: false,
        sale_of_data: false
      });
    }

    function saveCustom() {
      commit(null);
    }

    function openSettings() {
      if (!root) {
        pendingOpen = true;
        return;
      }
      if (!consent.decided) setBannerVisible(false);
      setModalOpen(true);
    }

    function shouldShowFromShopify(api) {
      if (mode === 'shopify' && api && typeof api.shouldShowBanner === 'function') {
        try { return !!api.shouldShowBanner(); } catch (e) { return true; }
      }
      return true;
    }

    function ingestShopifyConsent(api) {
      if (!api || typeof api.currentVisitorConsent !== 'function') return false;
      try {
        var current = api.currentVisitorConsent() || {};
        var hasValue = ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(function(k) {
          return current[k] === 'yes' || current[k] === 'no' || current[k] === true || current[k] === false;
        });
        if (!hasValue) return false;
        consent.analytics = boolFromShopify(current.analytics);
        consent.marketing = boolFromShopify(current.marketing);
        consent.preferences = boolFromShopify(current.preferences);
        consent.sale_of_data = boolFromShopify(current.sale_of_data);
        consent.decided = true;
        saveLocal();
        return true;
      } catch (e) {
        return false;
      }
    }

    document.addEventListener('click', function(e) {
      var openBtn = e.target.closest && e.target.closest('[data-bb-cookie-open]');
      if (openBtn) {
        e.preventDefault();
        openSettings();
        if (openBtn.hasAttribute('data-bb-cookie-ccpa') && qs('#bb-cookie-ccpa')) {
          qs('#bb-cookie-ccpa').focus();
        }
      }
    });

    if (window.location.hash === '#cookie-settings' || window.location.hash === '#do-not-sell') {
      pendingOpen = true;
    }
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#cookie-settings' || window.location.hash === '#do-not-sell') openSettings();
    });

    if (!root) return;

    var hadLocal = loadLocal();
    applyToggles();
    if (hadLocal && consent.decided) applyGtagConsent();

    if (banner) {
      on(qs('[data-bb-cookie-accept]', banner), 'click', acceptAll);
      on(qs('[data-bb-cookie-customize]', banner), 'click', function() { setModalOpen(true); });
    }
    if (overlay) {
      qsa('[data-bb-cookie-close]', overlay).forEach(function(el) {
        on(el, 'click', function() { setModalOpen(false); if (!consent.decided) setBannerVisible(true); });
      });
      qsa('[data-bb-cookie-accept]', overlay).forEach(function(el) { on(el, 'click', acceptAll); });
      on(qs('[data-bb-cookie-reject]', overlay), 'click', rejectOptional);
      on(qs('[data-bb-cookie-save]', overlay), 'click', saveCustom);
      qsa('[data-bb-cookie-toggle]', overlay).forEach(function(btn) {
        on(btn, 'click', function() {
          var key = btn.getAttribute('data-bb-cookie-toggle');
          consent[key] = !consent[key];
          applyToggles();
        });
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay && !overlay.hidden) {
        setModalOpen(false);
        if (!consent.decided) setBannerVisible(true);
      }
      if (e.key === 'Tab' && overlay && !overlay.hidden && dialog) {
        var list = getFocusable(dialog);
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    withPrivacy(function(api) {
      if (!hadLocal) ingestShopifyConsent(api);
      if (consent.decided) {
        setBannerVisible(false);
        applyGtagConsent();
        syncShopify();
        if (pendingOpen) openSettings();
        return;
      }
      if (shouldShowFromShopify(api)) setBannerVisible(true);
      if (pendingOpen) openSettings();
    });
  }

  /* ── Loox reviews: ensure script + heal stale carousel markup ── */
  function initLoox() {
    function hasLooxScript() {
      return !!document.querySelector('script[src*="loox.io/widget"]') || typeof window.Loox !== 'undefined';
    }

    function injectLooxScript() {
      if (hasLooxScript()) return;
      var shop = (window.Shopify && Shopify.shop) || '';
      if (!shop) return;
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://loox.io/widget/QiNd6fHVAR/loox.js?shop=' + encodeURIComponent(shop);
      document.head.appendChild(s);
    }

    function reloadLoox() {
      try {
        if (window.Loox && typeof window.Loox.reload === 'function') window.Loox.reload();
        window.dispatchEvent(new Event('resize'));
      } catch (e) {}
      hideLooxIframeChrome();
    }

    /* Loox header/tabs live in #looxReviewsFrame (loox.io). White text there
       cannot be restyled. Hide that chrome and keep our navy tabs. */
    var LOOX_CHROME_CLIP = 64;
    function hideLooxIframeChrome() {
      qsa('#looxReviews').forEach(function(host) {
        if (host.getAttribute('data-header') !== 'false') {
          host.setAttribute('data-header', 'false');
        }
      });
      var frame = document.getElementById('looxReviewsFrame');
      if (!frame) return;
      var host = frame.parentElement;
      if (!host) return;
      host.classList.add('bb-loox-frame-clip');
      frame.style.setProperty('margin-top', '-' + LOOX_CHROME_CLIP + 'px', 'important');
      function syncClip() {
        var raw = frame.style.height || frame.getAttribute('height') || '';
        var h = parseFloat(raw);
        if (!h || h < LOOX_CHROME_CLIP + 40) h = frame.offsetHeight;
        if (h > LOOX_CHROME_CLIP + 40) {
          host.style.height = (h - LOOX_CHROME_CLIP) + 'px';
          host.style.overflow = 'hidden';
        }
      }
      syncClip();
      if (!frame.getAttribute('data-bb-loox-clipped')) {
        frame.setAttribute('data-bb-loox-clipped', '1');
        if (window.MutationObserver) {
          new MutationObserver(syncClip).observe(frame, { attributes: true, attributeFilter: ['style', 'height'] });
        }
      }
    }

    function bindLooxTabs() {
      qsa('[data-bb-loox-chrome]').forEach(function(chrome) {
        if (chrome.getAttribute('data-bb-bound') === '1') return;
        chrome.setAttribute('data-bb-bound', '1');
        qsa('[data-bb-loox-tab]', chrome).forEach(function(btn) {
          on(btn, 'click', function() {
            var tab = btn.getAttribute('data-bb-loox-tab');
            qsa('[data-bb-loox-tab]', chrome).forEach(function(other) {
              var onTab = other === btn;
              other.classList.toggle('is-active', onTab);
              other.setAttribute('aria-selected', onTab ? 'true' : 'false');
            });
            var host = document.getElementById('looxReviews');
            if (!host) return;
            var box = host.closest('.bb-loox-reviews') || host;
            var pid = box.getAttribute('data-bb-product-id') || host.getAttribute('data-product-id') || productIdFromPage();
            if (pid) box.setAttribute('data-bb-product-id', pid);
            host.removeAttribute('data-upgraded');
            host.setAttribute('data-header', 'false');
            host.style.height = '';
            host.classList.remove('bb-loox-frame-clip');
            if (tab === 'store') {
              host.setAttribute('data-loox-aggregate', '');
              host.removeAttribute('data-product-id');
            } else {
              host.removeAttribute('data-loox-aggregate');
              if (pid) host.setAttribute('data-product-id', pid);
            }
            host.innerHTML = '';
            setTimeout(reloadLoox, 200);
            setTimeout(hideLooxIframeChrome, 800);
            setTimeout(hideLooxIframeChrome, 1800);
          });
        });
      });
    }

    function productIdFromPage() {
      var el = qs('[data-product-ids], [data-product-id], #looxReviews[data-product-id]');
      if (el) {
        return el.getAttribute('data-product-id') || (el.getAttribute('data-product-ids') || '').split(',')[0] || '';
      }
      if (window.meta && meta.product && meta.product.id) return String(meta.product.id);
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        return String(ShopifyAnalytics.meta.product.id || '');
      }
      return '7532069126203';
    }

    function swapCarouselLocally(root) {
      if (!root || root.getAttribute('data-bb-loox-healed') === '1') return;
      if (root.querySelector('#looxReviews')) {
        root.setAttribute('data-bb-loox-healed', '1');
        return;
      }
      var pid = productIdFromPage();
      root.innerHTML = '<div id="looxReviews" data-product-id="' + pid + '" data-header="false" class="loox-reviews-default"></div>';
      root.classList.remove('bb-loox-reviews--carousel');
      root.setAttribute('data-bb-loox-root', '');
      root.setAttribute('data-bb-loox-healed', '1');
    }

    function repairFromSectionApi() {
      var carousel = document.querySelector('.loox-v2-carousel-container');
      if (!carousel || document.getElementById('looxReviews')) return false;
      var section = carousel.closest('.shopify-section');
      if (!section || !section.id || section.id.indexOf('shopify-section-') !== 0) return false;
      var sectionId = section.id.slice('shopify-section-'.length);
      var url = window.location.pathname + window.location.search;
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data && data[sectionId];
          if (html && html.indexOf('looxReviews') !== -1) {
            section.outerHTML = html;
          } else {
            qsa('.bb-loox-reviews, #loox-default-carousel').forEach(function(node) {
              var root = node.classList.contains('bb-loox-reviews') ? node : (node.closest('.bb-loox-reviews') || node.parentElement);
              swapCarouselLocally(root);
            });
          }
          injectLooxScript();
          setTimeout(reloadLoox, 300);
          setTimeout(reloadLoox, 1200);
          setTimeout(reloadLoox, 2500);
        })
        .catch(function() {
          qsa('.bb-loox-reviews, #loox-default-carousel').forEach(function(node) {
            var root = node.classList.contains('bb-loox-reviews') ? node : (node.closest('.bb-loox-reviews') || node.parentElement);
            swapCarouselLocally(root);
          });
          injectLooxScript();
          setTimeout(reloadLoox, 800);
        });
      return true;
    }

    if (!qs('#looxReviews, [data-bb-loox-root], .loox-v2-carousel-container, .bb-loox-reviews, #product-reviews, #reviews')) {
      return;
    }

    // Prefer fresh section HTML (includes Loox metafield SSR). Fall back to local swap.
    if (!repairFromSectionApi()) {
      qsa('.bb-loox-reviews, #loox-default-carousel').forEach(function(node) {
        var root = node.classList.contains('bb-loox-reviews') ? node : (node.closest('.bb-loox-reviews') || node.parentElement);
        swapCarouselLocally(root);
      });
    }

    injectLooxScript();
    bindLooxTabs();
    setTimeout(injectLooxScript, 1200);
    setTimeout(hideLooxIframeChrome, 600);
    setTimeout(reloadLoox, 2000);
    setTimeout(hideLooxIframeChrome, 2800);
    var looxRoot = qs('#looxReviews, .bb-loox-reviews');
    if (looxRoot && window.MutationObserver) {
      var painted = false;
      var obs = new MutationObserver(function() {
        if (painted) return;
        painted = true;
        requestAnimationFrame(function() {
          hideLooxIframeChrome();
          bindLooxTabs();
          painted = false;
        });
      });
      obs.observe(looxRoot, { childList: true, subtree: true });
    }
  }

  /* ── Boot ── */
  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initNav();
    initDrawer();
    initNavDropdown();
    initFAQ();
    initIngTabs();
    initA11y();
    initCookieConsent();
    initAffiliateCalc();
    initAffiliateCollabs();
    initLoox();
  });

})();

/* loox-heal-20260821d */
